import React from "react";
import Image from "../../Assests/q3.png";
import classes from "./About.module.css";

const About = () => {
  return (
    <div id="about">
      <div className={classes.main_parent_about}>
        <div className={classes.main_child_about}>
            <div className={classes.child} data-aos="fade-right">
              <img src={Image} className={classes.my_image} alt="nikhil" />
            </div>
          <div className={classes.child} data-aos="fade-up">
            <div>
              <h3 className={classes.about_content}>About Me </h3>
              <p className={classes.about_content_text}>
                  I am Nikhil Gupta, born and raised in Jaipur, and I graduated from PIET Jaipur (Batch 2018-2022) in Computer Science. Web development is my specialty, and I enjoy creating websites and web applications. Playing with letterforms makes me happy, and hopefully, the result will bring smiles to others.
              </p>
              <div className={classes.about_content_text_list}>
                <ul>
                 <li>MERN/MEAN STACK</li>
                  <li>Java Script</li>
                  <li>Bootstrap</li>
                  <li>HTML & CSS</li>
                  <li>SQL</li>
                </ul>
                
                <a type="button" href ="https://drive.google.com/file/d/1EpleZ5wBPzrHYi2cww6b7afm7SpB-gfr/view?usp=share_link" rel="noreferrer" target="_blank">Resume</a>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
